module.exports = __webpack_public_path__ + "static/media/clock2.82dc1786.svg";